import { Component, OnInit } from '@angular/core';
import { EcasessionService } from './ecasessions.service';
// import {SocketService} from '../../socket.service';

@Component({
  selector: 'app-ecasessions',
  templateUrl: './ecasessions.component.html',
  styleUrls: ['./ecasessions.component.css']
})
export class EcasessionsComponent implements OnInit {
  sessionList: any[];
  selectedSession: any = {};
  subAdminArray: any[] = [];

  constructor(
    private  sessionService: EcasessionService,
    // private SocketService: SocketService
  ) { }

  ngOnInit(): void {
    this.getSessionList();
    //  this.SocketService.OpenChat().subscribe(() => {
    //   console.log("Ffffff");
    // })
  }

  getSessionList(){
    this.sessionService.sessionList().subscribe((dataResult: any)=>{
     // console.log("session list",dataResult);
      this.sessionList = dataResult.list;
      console.log(this.sessionList);
      this.selectedSession = this.sessionList[0];
    })
  }

  onDetailsClick(sessionId: string) {
    let temporaryMemberArray: any[];
    console.log(sessionId);
    for (const session of this.sessionList) {
      if (session._id == sessionId) {
        this.selectedSession = session;
      }
    }
    console.log(this.selectedSession);

    this.sessionService.sessionDetails({sessionId: sessionId}).subscribe((data: any) => {
      // console.log("session details", data.sessionId[0].memberDetails);
      temporaryMemberArray = data.sessionId[0].memberDetails;
      console.log(temporaryMemberArray);

      for (let member of temporaryMemberArray) {
        if (member.userType == 'SUBADMIN') {
          this.subAdminArray.push(member.name);
        }
      }
      console.log("subadmins", this.subAdminArray);
    })
  }

  onSessionSelect(sessionId: string, sessionStatus: string) {
    const userId = localStorage.getItem('userId');
    sessionStorage.setItem('sessionId',sessionId);
    console.log(sessionId, userId);
    // this.SocketService.sessionId.next(sessionId);
    // this.SocketService.sessionStatus.next(sessionStatus);
    let data={
      sessionId:sessionId,
      userId:userId
    }
    // this.SocketService.joinRoom(data);
  }
}
